export default __webpack_public_path__ + "static/media/pause.739ee03e.svg";